module.exports = __webpack_public_path__ + "img/banner1.1f50673c.jpg";